<!-- Ported from the Polaris kit: src/product/components/SettingsSection.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first.
     Hand change (phase P, 28/09): slot `footer`, a row under the section's controls for a Save that belongs to this
     section only (decision 6-Q5: one Save per section of the portal settings). The kit has none; empty, nothing shows. -->
<script setup>
// One topic of a settings page. The left column explains (title, a short description, a help link); the right
// column acts (rows). Measured rhythm: 10px title to description, 20px between rows. Below 1024px they stack.
import { useId } from 'vue';
import { Book16 } from '@carbon/icons-vue';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  help: { type: Object, default: null }, // { label }: emitted back with `help`
  wide: Boolean, // one column: the rows take the whole width
});
defineEmits(['help']);
const id = useId();
</script>

<template>
  <section :aria-labelledby="id" data-settings-section>
    <Card>
      <CardContent class="grid gap-6" :class="wide ? '' : 'lg:grid-cols-2'">
        <div class="grid content-start gap-2.5">
          <h2 :id="id" class="type-polaris-card-title">{{ title }}</h2>
          <p
            v-if="description"
            class="max-w-[21.25rem] type-polaris-body text-polaris-muted-foreground"
          >
            {{ description }}
          </p>
          <Button
            v-if="help"
            variant="link"
            size="sm"
            class="-mt-1.5 h-auto min-h-6 justify-self-start p-0 has-[>svg]:px-0"
            @click="$emit('help', help)"
          >
            <Book16 aria-hidden="true" />{{ help.label }}
          </Button>
        </div>
        <div class="grid min-w-0 content-start gap-5">
          <slot />
          <div
            v-if="$slots.footer"
            class="flex flex-wrap items-center justify-end gap-2"
          >
            <slot name="footer" />
          </div>
        </div>
      </CardContent>
    </Card>
  </section>
</template>
